module.exports = __webpack_public_path__ + "assets/img/mall-banner-01.722d1c1b.png";